import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1751">
      <Hero data-id="element-1752" />
      <WhyUs data-id="element-1753" />
      <Services data-id="element-1754" />
      <HowItWorks data-id="element-1755" />
      <FAQ data-id="element-1756" />
      <Reviews data-id="element-1757" />
      <CtaBanner data-id="element-1758" />
    </main>;
}